import React from 'react';
import { CTAButton } from './CTAButton';
import { LockIcon, CreditCardIcon, FileTextIcon, ZapIcon, BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-to-b from-[#071A14] to-[#0F2E23] pt-8 pb-4 px-3 relative overflow-hidden border-b-2 border-[#D4A843]" data-id="element-59">
      <div className="max-w-3xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-60">
        <h1 className="text-2xl md:text-4xl font-black text-[#FFFFFF] leading-tight mb-2 uppercase tracking-tighter" data-id="element-61">
          🌱 TODO TU SISTEMA DE EDUCACIÓN AMBIENTAL RURAL{' '}
          <span className="text-[#D4A843]" data-id="element-62">RESUELTO</span>
        </h1>

        <div className="my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 w-full max-w-lg relative" onClick={scrollToPricing} data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/e2neWSG3SH84mdjw3Df4FG/mockups_educacion_ambiental_rural_.png" alt="Kit Completo Educación Ambiental Rural" className="w-full h-auto relative z-10 glow-hero rounded-xl" data-id="element-64" />
        </div>

        <p className="text-[#BFC9C5] text-sm md:text-base font-bold mb-2 mt-3 max-w-xl mx-auto leading-snug" data-id="element-65">
          Clases, actividades, proyectos y contenido ambiental ya armados para
          que dejes de improvisar.
        </p>

        <div className="bg-[#102A1F] border border-[#D4A843] rounded px-3 py-1.5 mb-3 inline-block shadow-sm" data-id="element-66">
          <p className="text-[#FFFFFF] font-black text-sm md:text-base leading-none" data-id="element-67">
            👉 Llegás al aula sabiendo exactamente qué enseñar.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 mb-3" data-id="element-68">
          <div className="flex items-center gap-1.5 text-[#74C69D] text-[10px] md:text-xs font-bold whitespace-nowrap" data-id="element-69">
            <FileTextIcon className="w-3.5 h-3.5 text-[#D4A843]" strokeWidth={3} data-id="element-70" />
            PDF descargable
          </div>
          <div className="flex items-center gap-1.5 text-[#74C69D] text-[10px] md:text-xs font-bold whitespace-nowrap" data-id="element-71">
            <ZapIcon className="w-3.5 h-3.5 text-[#D4A843]" strokeWidth={3} data-id="element-72" />
            Acceso inmediato
          </div>
          <div className="flex items-center gap-1.5 text-[#74C69D] text-[10px] md:text-xs font-bold whitespace-nowrap" data-id="element-73">
            <BookOpenIcon className="w-3.5 h-3.5 text-[#D4A843]" strokeWidth={3} data-id="element-74" />
            Adaptado a currícula argentina
          </div>
        </div>

        <div className="flex justify-center mb-3 w-full max-w-sm" data-id="element-75">
          <CTAButton fullWidth className="py-3 text-base md:text-lg" data-id="element-76">
            ACCEDER AHORA
          </CTAButton>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 text-[#BFC9C5] text-[10px] md:text-xs font-bold mb-3" data-id="element-77">
          <div className="flex items-center gap-1 whitespace-nowrap" data-id="element-78">
            <ShieldCheckIcon className="w-3.5 h-3.5 text-[#D4A843]" data-id="element-79" /> Garantía
            7 días sin preguntas
          </div>
          <div className="flex items-center gap-1 whitespace-nowrap" data-id="element-80">
            <LockIcon className="w-3.5 h-3.5 text-[#D4A843]" data-id="element-81" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-1 whitespace-nowrap" data-id="element-82">
            <CreditCardIcon className="w-3.5 h-3.5 text-[#D4A843]" data-id="element-83" /> Mercado
            Pago | Tarjeta | Transferencia
          </div>
        </div>

        <div className="inline-block bg-[#0B211A] border border-[#1F3D2B] rounded-full px-3 py-1.5 shadow-inner" data-id="element-84">
          <p className="text-[#BFC9C5] text-[10px] md:text-xs font-bold flex items-center gap-1.5" data-id="element-85">
            <span className="text-[#D4A843] text-sm tracking-widest" data-id="element-86">
              ★★★★★
            </span>
            Más de 300 docentes ya tienen sus clases resueltas con este sistema.
          </p>
        </div>
      </div>
    </section>;
}